export default "__VITE_ASSET__Z3TTRXzC__"